import type { ReviewCounts } from "v2/types/extractionReview.types";

export const reviewProgress = (
  counts?: ReviewCounts
): { total: number; done: number; percent: number } => {
  const done =
    (counts?.confirmed ?? 0) + (counts?.rejected ?? 0) + (counts?.saved ?? 0);
  const total = done + (counts?.review_remaining ?? 0);
  return { total, done, percent: total ? Math.round((done / total) * 100) : 0 };
};
